import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ContactAddress } from "../../../../classes/contact/contact.class";
import { DynamicsClientService } from "../../../../data-services/dynamics-client/dynamics-client.service";
import { AddressDataService } from "../../../../data-services/address/address.data.service";
import { NavigationService, ChildNavNames, PageName } from "../../../../services/navigation/navigation.service";
import { IonNav, LoadingController, NavParams } from "@ionic/angular";
import { ContactOfflineService } from "../../../../services/contact/contact.service";
import { TranslateService } from "@ngx-translate/core";
import { AlertService } from "../../../../services/alert/alert.service";
import { IndHeaderLeftDataModel } from '@omni/models/indHeaderLeftDataModel';
import { EmailViewType } from '@omni/classes/activity/email.activity.class';
import { EmailService } from '@omni/services/email-templates/email.service';
import { DeviceService } from "@omni/services/device/device.service";


@Component({
    selector: 'add-contact-address',
    templateUrl: 'contact-address-add.html',
  styleUrls:['contact-address-add.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactNewAddressComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  public isDeviceOffline = false;
  trackById(index: number, item: any) { return item?.id || item?.ID || index; }


    public contactAddress: ContactAddress[] = [];
    public dynamics: DynamicsClientService;
    public query: string = '';
    public selectedaddress: ContactAddress;
    public loading:boolean = false;
    public noResult:boolean = false;
    private from: PageName;
    indHeaderLeftModel: IndHeaderLeftDataModel;

    constructor(
        private contactService: ContactOfflineService,
        private addressService: AddressDataService,
        private alertService: AlertService,
        private navService: NavigationService,
        private navParams: NavParams,
        private translate:TranslateService,
        private navCtrl: IonNav,
        private emailService: EmailService,
        private loadingCtrl: LoadingController,
        public device: DeviceService,
        private readonly cdRef: ChangeDetectorRef,
    ) {
        this.from = (this.navParams.data && this.navParams.data.from);
    }

    ngOnInit(){
      this.isDeviceOffline = this.device.isOffline;
      this.device.isOfflineObservable.pipe(takeUntil(this.destroy$)).subscribe(isOffline => {
        this.isDeviceOffline = isOffline;
        this.cdRef.markForCheck();
      });
      this.initHeader();
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

    public initHeader(){
      this.indHeaderLeftModel = {
        id: 'contact-address-header-left',
        title: this.translate.instant('CHOOSE_ADDRESS'),
        controls: [
          {
            id: "close",
            imgSrc: 'assets/imgs/header_cancel.svg',
            name: this.translate.instant('CANCEL'),
            isDisabled: false,
            align: "right"
          },
          {
            id: "done",
            imgSrc: 'assets/imgs/header_complete.svg',
            name: this.translate.instant('DONE'),
            isDisabled: !this.selectedaddress,
            align: "right"
          }
        ],
      };
    }

    public onPageTitleControlClick(id){
      if(id==='close'){
        this.closepage(true);
      }
      if(id==='done'){
        this.closepage(false);
      }
    }

    continueClose() {
      if (this.emailService.viewType === EmailViewType.CREATE_FROM_MEETING ||
        this.emailService.viewType === EmailViewType.CREATE_FROM_PHONE_CALL) {
          this.navCtrl.pop();
      } else {
        this.navService.popWithPageTracking();
      }
    }

    closepage(isCancel:boolean) {
        if(!isCancel){
            this.addressService.selectAddress(this.selectedaddress);
            if (this.from && this.from === PageName.ConsentDetailsComponent) {
              // this.navService.popWithPageTracking();
              this.continueClose();
            } else {
              this.navService.popChildNavPageWithPageTracking();
            }
            // this.viewCtrl.dismiss();
        }else{
            if(this.selectedaddress){
              let cancelText = this.translate.instant("CANCEL");
              if(this.translate.currentLang == 'it') {
                cancelText = this.translate.instant("CANCEL_BUTTON_DISCARD_CHANGE");
              }
              this.alertService.showAlert({
                title: this.translate.instant('DISCARD_CHANGES'),
                message: this.translate.instant('CONTACT_R_U_WANT_CANCEL_LOSE_CHANGES')}, this.translate.instant('DISCARD_CONTACT_CR'), cancelText
              ).then (res => {
                if(res.role == "ok") {
                  this.addressService.selectAddress(null);
                  if (this.from && this.from === PageName.ConsentDetailsComponent) {
                    // this.navService.popWithPageTracking();
                    this.continueClose();
                  } else {
                    this.navService.popChildNavPageWithPageTracking();
                  }
                }
              });

            } else {
                this.addressService.selectAddress(null);
                if (this.from && this.from === PageName.ConsentDetailsComponent) {
                  // this.navService.popWithPageTracking();
                  this.continueClose();
                } else {
                  this.navService.popChildNavPageWithPageTracking();
                }
                // this.viewCtrl.dismiss();
            }
        }
    }

    async searchAddressGlobally(event) {
        let query = '';
        if (event?.target?.value) {
          query = event.target.value.trim();
        }
        if (query.length > 2) {
          this.loading = true;
          let loader = await this.loadingCtrl.create();
          try {
              loader.present();
              this.contactAddress = [];
              const result = await this.addressService.getGlobalAddresses(query);
              if (result) {
                this.noResult = result.length === 0;
                await this.mapAddress(result);
                loader.dismiss();
              } else {
                this.noResult = true;
                loader.dismiss();
              }
          } catch (error) {
                loader.dismiss();
          } finally {
            this.loading = false;
            loader.dismiss();
            this.cdRef.markForCheck();
          }
        }
    }

    clearSearch(ev){
        this.noResult = false;
        this.contactAddress = [];
        this.selectedaddress = undefined;
        this.initHeader();
    }

    selectAddress(address: ContactAddress) {
        this.selectedaddress = address;
        this.initHeader();
    }

    async mapAddress(result) {
        this.contactAddress = [];
        result.forEach(address => {
            let addObj: ContactAddress = {
                city: address['_indskr_city_lu_value@OData.Community.Display.V1.FormattedValue'] || '',
                state: address['_indskr_state_lu_value@OData.Community.Display.V1.FormattedValue'] || '',
                postal: address['_indskr_postalcode_lu_value@OData.Community.Display.V1.FormattedValue'] || '',
                country: address['_indskr_country_lu_value@OData.Community.Display.V1.FormattedValue'] || '',
                countryCode: '',
                street: address['indskr_line1'] || '',
                street2: address['indskr_line2'] || '',
                street3: address['indskr_line3'] || '',
                postOfficeBox: address['indskr_postofficebox'] || '',
                isPrimary: false,
                addressId: address['indskr_addressid'] || '',
                compositeAdd: address['indskr_composite'],
                primaryContact: '',
                fax: '',
                fax2: '',
                telephone1: '',
                telephone2: '',
                isSampleEligible: false,
                customerAddressID: '',
                isNew: true,
                concatanatedAddress: ''
            };
            const isExists = this.contactService.tempContactInformation.addressesList.some(acc => acc.addressId === addObj.addressId);
            if(!isExists) this.contactAddress.push(addObj);
        });
    }
}
